import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Viewer from 'v-viewer'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import { installInterceptors, setErrorNotifier } from './http'

// Re-eksport dla starszych importów `{Const} from '.../main'`.
export { Const } from './config'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'viewerjs/dist/viewer.css'

const VueUploadComponent = require('vue-upload-component')

Vue.use(BootstrapVue)
Vue.use(Viewer)
Vue.component('file-upload', VueUploadComponent)

Vue.config.productionTip = false

installInterceptors()

const root = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

// Globalny toast dla błędów HTTP (podpinany po utworzeniu instancji,
// bo interceptory w http.js nie mają dostępu do $bvToast).
setErrorNotifier(messageKey => {
    root.$bvToast.toast(i18n.t(messageKey), {
        title: i18n.t('errors.title'),
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-top-center',
    })
})
